import { h, Fragment } from "preact";
import { Card, Typography } from "antd";
import { useParams } from "react-router-dom";


export default function ManualReviewPersonPage(props){

    const { person_id } = useParams()

    console.log(person_id)

    return (
        <>
            <Card className="session__card session-card"
                    bordered={false}
                    title={
                        <Typography.Title level={4}>
                            Detailed Report
                        </Typography.Title>
                    }
            >

            </Card>
        </>
    )
}